<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "UserAdvertsWrapper"
    }
</script>

<style scoped>

</style>